module.exports = __webpack_public_path__ + "static/media/bv.78bef910.svg";